import {
  GET_TABLERO,
  GET_TABLERO_SUCCESS,
  GET_TABLERO_ERROR,
  GET_TABLERO_VERSION,
  TABLERO_VERSION_ERROR,
  CHANGE_APPLICANT_MARK,
  TableroState,
  InitialState,
  TableroActions,
} from './types'

const TableroReducer = (state: TableroState = InitialState, action: TableroActions): TableroState => {
  switch (action.type) {
    case GET_TABLERO:
      return {
        ...state,
        loading: true,
        error: false,
        versionError: false,
      }
    case GET_TABLERO_SUCCESS:
      return {
        ...state,
        tablero: action.payload,
        loading: false,
        error: false,
        versionError: false,
      }
    case GET_TABLERO_ERROR:
      return {
        ...state,
        tablero: null,
        loading: false,
        error: true,
        versionError: false,
      }
    case GET_TABLERO_VERSION:
      return {
        ...state,
        ...(state.tablero && {
          tablero: { ...action.payload },
        }),
        versionError: false,
      }
    case TABLERO_VERSION_ERROR:
      return {
        ...state,
        loading: false,
        error: false,
        versionError: true,
      }
    case CHANGE_APPLICANT_MARK:
      return {
        ...state,
        tablero: action.payload,
      }
    default:
      return state
  }
}

export default TableroReducer
